import { CounterIcon } from '@elements/tab/tab.helpers';
import { i18n } from '@localization';
import { jsx as _jsx } from "react/jsx-runtime";
export var getTabs = function getTabs(count) {
  return function () {
    return [{
      key: 1,
      label: i18n.t('components.modals.addNewGroup.general'),
      value: i18n.t('components.modals.addNewGroup.general')
    }, {
      key: 2,
      label: i18n.t('components.modals.addNewGroup.members'),
      value: i18n.t('components.modals.addNewGroup.members'),
      icon: /*#__PURE__*/_jsx(CounterIcon, {
        count: count,
        iconPosition: "end"
      }),
      iconPosition: 'end'
    }];
  };
};
export var members = ['Black Marvin', 'Black Ollie', 'Allen Ann', 'Veeeeeeeeeerrrryyyyy LLLLOOOOOOOONG NAAAAAAAAMMEEEEEEEEEEEE', 'Alvarez Nadia', 'Zimmerman Robert', 'Nguyen Shane', 'Cooper Kristin'];